import { provideConstants } from '../providers/provide-constants';

export const provideMockConstants = () => provideConstants();